
import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { BarChart3, PieChartIcon } from "lucide-react";
import PieChartDisplay from "../charts/PieChartDisplay";
import StackedBarChart from "../charts/StackedBarChart";

interface OpmerkingenTabProps {
  commentsData: any[];
  commentsProcessingData: any[];
}

const OpmerkingenTab: React.FC<OpmerkingenTabProps> = ({
  commentsData,
  commentsProcessingData
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="space-y-1">
            <CardTitle className="text-base">Opmerkingen per categorie</CardTitle>
            <CardDescription>Verdeling van opmerkingen per type</CardDescription>
          </div>
          <PieChartIcon className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <PieChartDisplay data={commentsData} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="space-y-1">
            <CardTitle className="text-base">Verwerking opmerkingen</CardTitle>
            <CardDescription>Status van verwerking per opmerking</CardDescription>
          </div>
          <BarChart3 className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <StackedBarChart
            data={commentsProcessingData}
            keys={[
              { dataKey: "verwerkt", name: "Verwerkt", color: "#34C759" },
              { dataKey: "openstaand", name: "Openstaand", color: "#FF3B30" }
            ]}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default OpmerkingenTab;
